// extracted by mini-css-extract-plugin
module.exports = {"image":"da51a739f7--image--HCbCM","image-icon":"da51a739f7--image-icon--WW3ow"};